import moment from "moment";

export const standardDate = (date) => {
  return moment(date).format("YYYY-MM-DD");
};

export const impexDateFormat = (date) => {
  const newDate = moment(date).format("DD-MM-YYYY");
  if (newDate === "Invalid date") {
    return "-";
  } else {
    return newDate;
  }
};

export const startOf = (period) => {
  return standardDate(moment().startOf(period));
};

export const endOf = (period) => {
  return standardDate(moment().endOf(period));
};

export const today = (includeTime = false) => {
  if (includeTime === true) {
    return moment();
  }
  return standardDate(moment());
};

export const dateBeforeMonths = (beforeMonthCount) => {
  return standardDate(moment().subtract(beforeMonthCount, "months"));
};

export const dateAfterMonths = (afterMonthCount) => {
  return standardDate(moment().add(afterMonthCount, "months"));
};

export const getCountBetweenTwoDates = (fromDate = moment(), toDate) => {
  return moment().diff(fromDate, toDate);
};

export const getMonthListBetweenTwoDates = (fromDate, toDate) => {
  var dateStart = moment(fromDate);
  var dateEnd = moment(toDate);
  var timeValues = [];

  while (dateEnd > dateStart || dateStart.format("M") === dateEnd.format("M")) {
    timeValues.push(dateStart.format("MMMM-YYYY"));
    dateStart.add(1, "month");
  }
  return timeValues;
};
